import { useCallback, useState } from 'react';
import { useReframe } from 'nike-re-framejs';
import { loggedIn$ } from '../turboLive/subs';
import { browserInfo } from '../../common/util';
import i18n from '../../common/i18n';
import { reqNotifyPermThenSync } from '../../common/messaging/firebaseInit';
import { nuiCtx } from '../../common/initialization';
import { MessageDialog, openDialog } from '../dialogs/dialogs';

export default function useNotificationHandlerWrapper(info = browserInfo()) {
    const { browserGranted, browserSupported } = info;
    const { subscribe } = useReframe();
    const loggedIn = subscribe(loggedIn$);
    const [, repaint] = useState(0);
    const wrappedHandler = useCallback(
        handler => (...args) => {
            if (!loggedIn) {
                nuiCtx.openLoginDialog(i18n('nui.notifications.loggedOut'));
                return;
            }
            reqNotifyPermThenSync()
                .then(() => {
                    if (browserGranted) {
                        return handler(...args);
                    } else {
                        const info = browserInfo();
                        if (info.browserGranted) {
                            repaint(i => i + 1);
                            return handler(...args);
                        } else if (info.browserDenied) {
                            openDialog(MessageDialog, { message: i18n('nui.notifications.blocked') });
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    repaint(i => i + 1);
                });
        },
        [browserGranted, loggedIn]
    );
    return { browserSupported, withRegisteredNotif: browserSupported ? wrappedHandler : null };
}
